import { Link as RouterLink } from 'react-router-dom';
import { Badge, Box, Button, Text, VStack } from '@chakra-ui/react';
import { MarketingPlanBody } from '../components/marketingPlan/MarketingPlanBody';
import { readMarketingPlans } from '../components/marketingPlan/model';
import { planDetailHref } from '../marketingPlans/detail';

/** Operator-agent shell for a marketing plan summary, with an open detail. */
export function MarketingPlanCard({ payload }: { payload: unknown }) {
  const view = readMarketingPlans(payload);
  const list = view.kind === 'marketingPlanList' || view.plans.length > 1;
  const plan = view.plans.length === 1 ? view.plans[0] : null;
  const title = list
    ? `${view.plans.length} ${view.plans.length === 1 ? 'plan' : 'plans'}`
    : (plan?.title ?? 'Marketing plan');
  const label = list ? 'Marketing plans' : 'Marketing plan';
  const brandId = typeof localStorage === 'undefined' ? null : localStorage.getItem('brand_id');
  return (
    <Box
      data-testid="marketing-plan"
      data-card-kind={view.kind}
      p={3}
      borderWidth="1px"
      borderColor="brand.border"
      borderRadius="md"
      bg="brand.surface"
      role="group"
      aria-label={`${label}: ${title}`}
    >
      <VStack align="flex-start" spacing={0} mb={1}>
        <Text fontSize="11px" color="brand.muted" textTransform="uppercase" letterSpacing="0.5px">{label}</Text>
        <Box display="flex" alignItems="center" gap="8px" flexWrap="wrap">
          <Text fontSize="14px" fontWeight="700">{title}</Text>
          {!list && plan?.status ? <Badge>{plan.status}</Badge> : null}
        </Box>
      </VStack>
      <MarketingPlanBody view={view} />
      {view.plans.some((item) => item.id) && (
        <Box mt={2} display="flex" gap="8px" flexWrap="wrap">
          {view.plans.filter((item) => item.id).map((item) => (
            <Button
              as={RouterLink}
              key={item.id ?? item.title}
              to={planDetailHref(brandId, item.id ?? '', item.revision)}
              size="xs"
              variant="outline"
            >
              {`Open ${item.title}`}
            </Button>
          ))}
        </Box>
      )}
    </Box>
  );
}
